<template>
  <PropertyDetailsCard>
    <template #title>Accessibility</template>
    <template #action>
      <PropertyDetailsCardEditButton v-if="hasInfo" @click="showModal" />
    </template>

    <PropertyAccessibilityInfo v-if="hasInfo" :property="property" />
    <PropertyDetailsCardPlaceholder
      v-else
      title="You haven't added accessibility yet"
      subtitle="Listing how to access your rental allows Tallo to answer questions with context"
      button-text="Add accessibility"
      @button-clicked="showModal"
    />
    <PropertyAccessibilityModal ref="accessibilityModalRef" />
  </PropertyDetailsCard>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';

import { usePropertyStore } from '@tallo/investor/property';
import {
  PropertyAccessibilityInfo,
  PropertyDetailsCard,
  PropertyDetailsCardEditButton,
  PropertyDetailsCardPlaceholder,
} from '@tallo/property';

import PropertyAccessibilityModal from './property-accessibility-modal.vue';

const accessibilityModalRef = ref<InstanceType<typeof PropertyAccessibilityModal>>();
const { property } = usePropertyStore();
const hasInfo = computed(() => Boolean(property?.accessibility));

function showModal() {
  accessibilityModalRef.value?.modalRef?.show();
}
</script>
